import restoImage from "../../ASSETS/Image/top-view-cooked-chicken-spiced-up-with-potatoes-dark-surface.jpg";
import { IoIosEye, IoIosEyeOff, IoIosLock } from "react-icons/io";
import Loading from '../../COMPONENTS/Loading';
import { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { newPassword } from "../../API/login/newPassword";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function NewPassword() {
  let navigate = useNavigate()
  const [loading, setLoading] = useState(true);
  const [passwordVisible,setPasswordVisible]=  useState(false)
  const [passwordConfirmVisible,setPasswordConfirmVisible]=  useState(false)
      useEffect(() => {
        const timer = setTimeout(() => {
          // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
          setLoading(false);
        }, 2000); // 5000 millisecondes = 5 secondes
    
        // Nettoyer le timer si le composant est démonté avant la fin du délai
        return () => clearTimeout(timer);
      }, []);

      useEffect(()=>{
         if(JSON.parse(localStorage.getItem('email')) === null){
             navigate('/forgotPassword')
         }
      })
     
      const [credentials,setCredentials] = useState({
        pass:'',
        passconfirm:'',
        email:JSON.parse(localStorage.getItem('email'))
       
      })
    
      const onChange = (e)=>{
             setCredentials({
              ...credentials,
                 [e.target.name]:e.target.value
             })
      } 
     
     const [errors,setErrors] = useState({})
      const onSubmit = async (e) => {
        e.preventDefault();
        //console.log(credentials)
        try{
            if(credentials.pass !== credentials.passconfirm){
              toast.error('Les deux mots de passe ne sont pas identique');
            }else{
              const response = await newPassword(credentials);
              if(response.status === 422) {
                const validationErrors = response.errors;
                setErrors(validationErrors);
            
                if (typeof validationErrors === 'string') {
                    toast.error(validationErrors);
                } else {
                    for (const key in validationErrors) {
                        if (validationErrors.hasOwnProperty(key)) {
                            const error = validationErrors[key];
                            if (Array.isArray(error)) {
                                error.forEach(errMsg => {
                                    toast.error(errMsg);
                                });
                            } else {
                                toast.error(error);
                            }
                        }
                    }
                }
            }
            
              if(response.status === 200){
                toast.success(response.message)
                localStorage.removeItem('email')
                let mdp = 'status'
                localStorage.setItem('mdp',mdp)
                navigate('/login')
              }
              if(response.status === 500){
                console.log("Erreur ",response.message)
              }
            }
        }catch(error){
          console.log("Erreur lors de l'appel ",error)
        }
      };

      const handleVisibilityOff = ()=>{
        setPasswordVisible(true)
      }
      const handleVisibilityOn = ()=>{
        setPasswordVisible(false)
      }

      const handleConfirmVisibilityOff = ()=>{
        setPasswordConfirmVisible(true)
      }
      
      const handleConfirmVisibilityOn = ()=>{
        setPasswordConfirmVisible(false)
      }
     const {t,i18n} = useTranslation()


  return (
    <div>
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
      <div
      className="bg-center bg-cover bg-no-repeat h-screen flex  justify-center"
      style={{ backgroundImage: `url(${restoImage})` }}
    > 
     {/*  <ToastContainer /> */}
          <form onSubmit={onSubmit} className="bg-white w-[600px] flex flex-col space-y-7 text-lg items-center justify-center ">
            <div className="text-2xl font-bold zen-tokyo-zoo-regular mt-4">AZ</div>
            <div className="text-2xl font-bold zen-tokyo-zoo-regular">ON-SITE</div>
            <div className="font-semibold">{t("Reinitialisation du mot de passe")}</div>
              
             <div className="bg-[#EEEEEE] s:w-[400px] xs:w-[240px] sm:w-[300px] flex flex-row items-center px-3 justify-between">
                  <div className="flex items-center">
                      <IoIosLock className="text-[#a5a5a5] text-xl" />
                      <input
                        type={passwordVisible ? 'text' : 'password'}
                        value={credentials.pass}
                        name="pass"
                        onChange={onChange}
                        className=" h-12 px-3 bg-transparent outline-none text-base"
                       placeholder={t("Nouveau mot de passe")}
                      
                      />
                  </div>
                  <div className="">
                        {
                        !passwordVisible && (
                          <IoIosEyeOff className="text-[#a5a5a5] text-xl "  onClick={handleVisibilityOff}  />
                        )
                      }
                      {
                        passwordVisible && (
                          <IoIosEye className="text-[#a5a5a5] text-xl"  onClick={handleVisibilityOn} />
                        )
                      }
                    
                  </div>
             </div> 
            {errors.pass && <p className="text-red-500 text-xs mt-1">{errors.pass}</p> }

             <div className="bg-[#EEEEEE] s:w-[400px] xs:w-[240px] sm:w-[300px] flex flex-row items-center px-3 justify-between">
                  <div className="flex items-center">
                      <IoIosLock className="text-[#a5a5a5] text-xl" />
                      <input
                        type={passwordConfirmVisible ? 'text' : 'password'}
                        value={credentials.passconfirm}
                        name="passconfirm"
                        onChange={onChange}
                        className=" h-12 px-3 bg-transparent outline-none text-base"
                        placeholder={t("Confirmer le mot de passe")}
                      
                      />
                  </div>
                  <div className="">
                        {
                        !passwordConfirmVisible && (
                          <IoIosEyeOff className="text-[#a5a5a5] text-xl "  onClick={handleConfirmVisibilityOff}  />
                        )
                      }
                      {
                       passwordConfirmVisible && (
                          <IoIosEye className="text-[#a5a5a5] text-xl"  onClick={handleConfirmVisibilityOn} />
                        )
                      }
                    
                  </div>
             </div>  
            {errors.passconfirm && <p className="text-red-500 text-xs mt-1">{errors.passconfirm}</p>}
          
            <button className="bg-[#D19E06] transition ease-in-out delay-150 hover:-translate-y-1 
                      hover:scale-110 duration-700 hover:bg-white hover:text-[#D19E06] s:w-[400px] 
                      xs:w-[240px] sm:w-[300px] text-white h-12">
                        {t("Reinitialiser")}
            </button>
            {/* <Link to='/' className="flex hover:text-[#D19E06] items-center space-x-2 text-sm">
              <IoReturnUpBack className="text-xl" />
              <div>Retour a la page d'accueil</div>
            </Link> */}
          </form>
      </div>
      </>
      )}
    </div>
   
  );
}

export default NewPassword;
